import React, { Component } from "react";
import { BaseURLDev, headers } from "../../../../../_utils/config";
import { toDMYDate } from "../../../../../_utils/convert_datetime";
import {
  Segment,
  Button,
  Table,
  Menu,
  Popup,
  Radio,
  Loader,
  Pagination,
  Input,
  Header,
} from "semantic-ui-react";
import _ from "lodash";
import "react-confirm-alert/src/react-confirm-alert.css";
import STSAdd from "./_addsts/STSAdd";
import ModalDetail from "./ModalDetail";
import ModalEdit from "./ModalEdit";
import swal from "sweetalert";
import { toIDR } from "../../../../../_utils/tocurrency";

export default class BPNonSTS extends Component {
  constructor(props) {
    super(props);
    this.state = {
      column: null,
      data: [],
      direction: null,
      requests: true,

      // ======= start testing pagination client
      result: [],
      result_search: [],
      activePage: 1,
      totalPages: 0,
      itemPerPage: 10,
      page: 1,
      startfrom: 0,
      // ======= end testing pagination client

      q: "",

      data_post: [],
      is_open: false,
      loading_open: false,

      is_detail: false,
      data_detail: null,
      loading_detail: false,

      is_edit: false,
      data_edit: null,
      loading_edit: false,
      pageActive: 1,
      count: 0,
      limit: 0,
    };

    this.onToggleRadio = this.onToggleRadio.bind(this);
    this.searchBpNonSts = this.searchBpNonSts.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.onOpenAddSTS = this.onOpenAddSTS.bind(this);
    this.onCloseAddSTS = this.onCloseAddSTS.bind(this);
    this.onCloseDetail = this.onCloseDetail.bind(this);
    this.onOpenDetail = this.onOpenDetail.bind(this);
    this.onCloseEdit = this.onCloseEdit.bind(this);
    this.onOpenEdit = this.onOpenEdit.bind(this);
    this.onRefresh = this.onRefresh.bind(this);
  }

  onOpenEdit = (e, { index }) => {
    const { result } = this.state;
    this.setState({
      is_edit: true,
      data_edit: result[index],
      loading_edit: false,
    });
  };

  onCloseEdit = () => this.setState({ is_edit: false, data_edit: null });

  onOpenDetail = (e, { index }) => {
    const { result } = this.state;
    this.setState({
      is_detail: true,
      data_detail: result[index],
      loading_detail: false,
    });
  };

  onCloseDetail = () => this.setState({ is_detail: false, data_detail: null });

  onOpenAddSTS = () => {
    this.setState({
      is_open: true,
      loading_open: false,
    });
  };

  onCloseAddSTS = () => this.setState({ is_open: false });

  onAddCount(rincian) {
    let count = 0;
    for (let i = 0; i < rincian.length; i++) {
      count += rincian[i].nilai;
    }

    return this.state.count + count;
  }

  onMinusCount(rincian) {
    let count = 0;
    for (let i = 0; i < rincian.length; i++) {
      count += rincian[i].nilai;
    }

    return this.state.count - count;
  }

  onToggleRadio = (e, el) => {
    const { data_post, limit } = this.state;

    // if(el.checked && limit <= 14){
    if (el.checked) {
      const newRes = this.state.result.slice();
      newRes[el.index].status = true;
      this.setState({ result: newRes });

      if (data_post.indexOf(el.value) === -1) {
        this.setState({
          count: this.onAddCount(newRes[el.index].rincian),
          data_post: [...this.state.data_post, el.value],
          // limit: this.state.limit+1
        });
      }
    } else if (!el.checked) {
      const newRes = this.state.result.slice();
      newRes[el.index].status = false;
      this.setState({ result: newRes });

      if (data_post.indexOf(el.value) > -1) {
        data_post.splice(data_post.indexOf(el.value), 1);
        this.setState({
          count: this.onMinusCount(newRes[el.index].rincian),
          data_post: data_post,
          // limit: this.state.limit-1
        });
      }
      // }else if (el.checked && limit > 14) {
      //   swal("Maaf, untuk pembuatan STS kami batasi hanya 15 BP. Silahkan membuat STS baru!", {
      //      icon: "warning",
      //   });
      //   return false;
    }
  };

  handleSort = (clickedColumn) => () => {
    const { column, data, direction } = this.state;

    if (column !== clickedColumn) {
      this.setState({
        column: clickedColumn,
        data: _.sortBy(data, [clickedColumn]),
        direction: "ascending",
      });

      return;
    }

    this.setState({
      data: data.reverse(),
      direction: direction === "ascending" ? "descending" : "ascending",
    });
  };

  onRefresh() {
    this.setState({
      count: 0,
      data_post: [],
      data: [],
      result: [],
      result_search: [],
      q: "",
      requests: true,
    });
    this.onLoadData();
  }

  onLoadData() {
    this.setState({ requests: true });
    const startfrom = (this.state.page - 1) * this.state.itemPerPage;

    fetch(`${BaseURLDev}/bp?status=1`, { headers })
      .then((response) => {
        if (!response.ok) {
          swal("Load data gagal", { icon: "error" });
          this.setState({ requests: false });
          return Promise.reject(response.statusText);
        }
        return response.json();
      })
      .then((resJSON) => {
        this.setState({
          totalPages: Math.ceil(resJSON.data.length / this.state.itemPerPage),
          data: resJSON.data,
          result: resJSON.data.slice(
            startfrom,
            startfrom + this.state.itemPerPage
          ),
          requests: false,
          startfrom: startfrom,
        });
      })
      .catch((err) => {
        swal(
          "Load data gagal, Mohon periksa koneksi internet anda\natau sedang terjadi gangguan di server",
          {
            icon: "error",
          }
        );
      });
  }
  componentWillMount() {
    this.onLoadData();
  }

  handlePaginationChange = (e, { activePage }) => {
    if (this.state.pageActive === activePage) {
      return false;
    }

    this.setState({ activePage, pageActive: activePage, requests: true });
    const startfrom = (activePage - 1) * this.state.itemPerPage;

    if (this.state.q === "") {
      this.setState({
        startfrom: startfrom,
        result: this.state.data.slice(
          startfrom,
          startfrom + this.state.itemPerPage
        ),
        requests: false,
      });
    } else {
      // const startfrom = (activePage-1)*this.state.itemPerPage
      this.setState({
        startfrom: startfrom,
        result: this.state.result_search.slice(
          startfrom,
          startfrom + this.state.itemPerPage
        ),
        requests: false,
      });
    }
  };

  searchBpNonSts(e) {
    // this.setState({q:e.target.value, requests:false});
    // fetch(`${BaseURLDev}/bp?q=${e.target.value}&status=1`,{headers})
    // .then(response => {
    //     if (!response.ok) {
    //           return Promise.reject(response.statusText);
    //       }
    //     return response.json();
    // })
    // .then(resJson => {
    //     this.setState({
    //       data:resJson.data,
    //       totalPages:resJson.totalPage,
    //       requests:false
    //     })
    // });

    const query = e.target.value.toLowerCase();
    const { data } = this.state;
    const startfrom = (this.state.page - 1) * this.state.itemPerPage;

    this.setState({ q: query, requests: true });

    if (query.length > 0) {
      var results = [];
      for (let i = 0; i < data.length; i++) {
        for (let key in data[i]) {
          if (data[i][key].toLowerCase().indexOf(query) !== -1) {
            results.push(data[i]);
          }
        }
      }
      this.setState({
        totalPages: Math.ceil(results.length / this.state.itemPerPage),
        result_search: results,
        result: results.slice(startfrom, startfrom + this.state.itemPerPage),
        requests: false,
        startfrom: startfrom,
      });
    } else {
      this.setState({
        totalPages: Math.ceil(data.length / this.state.itemPerPage),
        result: data.slice(startfrom, startfrom + this.state.itemPerPage),
        requests: false,
        startfrom: startfrom,
      });
    }
  }

  onDelete(public_id, index) {
    swal({
      title: "Apakah anda yakin?",
      text: "BP ini tidak akan dihapus permanent tetapi tidak bisa dijadikan STS",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((verif) => {
      if (verif) {
        this.setState({ loadingDelete: true });
        fetch(`${BaseURLDev}/bp/ontrash/${public_id}`, {
          headers,
          method: "DELETE",
        })
          .then((response) => {
            if (!response.ok) {
              swal("Delete BP gagal", { icon: "error" });
              this.setState({ loadingDelete: false });
              return Promise.reject(response.statusText);
            }
            return response.json();
          })
          .then((parsedJSON) => {
            const { data } = this.state;
            const slice_data = data.slice();
            slice_data.splice(index, 1);
            this.setState({
              data: slice_data,
              loadingDelete: false,
            });
            swal("Delete BP Sukses", {
              icon: "success",
            });
          });
      } else {
        return false;
      }
    });
  }

  render() {
    const { column, result, data, direction, totalPages, activePage, limit } =
      this.state;
    return (
      <div>
        <div>
          <Menu>
            <Menu.Item>
              <Button
                disabled={this.state.data_post.length === 0}
                onClick={this.onOpenAddSTS}
                content="Buat STS"
                color="red"
                icon="shop"
                label={{
                  basic: true,
                  color: "blue",
                  pointing: "left",
                  content: `${
                    this.state.data_post.length
                  } BP terpilih (Total : ${toIDR(this.state.count)})`,
                }}
              />
            </Menu.Item>
            <Menu.Item>
              <Button.Group size="small">
                {/* <Button content="Filter" disabled={this.state.startDate===null && this.state.endDate===null} color='green' icon='filter' onClick={this.onFilter}/> */}
                {/* <Button content="Export" disabled={this.state.requests} color='red' icon='download' onClick={this.onOpenExport} /> */}
                <Button
                  color="blue"
                  disabled={this.state.requests}
                  content="Refresh"
                  icon="refresh"
                  onClick={this.onRefresh}
                />
              </Button.Group>
            </Menu.Item>
            <Menu.Item>
              <Header>List BP belum STS</Header>
            </Menu.Item>
            <Menu.Item position="right">
              <Input
                type="text"
                icon="search"
                autoFocus
                placeholder="Masukkan Nomor BP"
                style={{ width: "200px" }}
                value={this.state.q}
                onChange={this.searchBpNonSts}
              />
            </Menu.Item>
          </Menu>
          <Segment
            loading={
              this.state.loading_open ||
              this.state.requests ||
              this.state.loading_edit ||
              this.state.loading_detail
            }
          >
            <Table size="small" sortable celled>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell colSpan="8">
                    <Pagination
                      activePage={activePage}
                      onPageChange={this.handlePaginationChange}
                      totalPages={totalPages}
                    />
                  </Table.HeaderCell>
                </Table.Row>
                <Table.Row>
                  <Table.HeaderCell
                    style={{ width: "3%", textAlign: "center" }}
                  >
                    No.
                  </Table.HeaderCell>
                  <Table.HeaderCell
                    colSpan="2"
                    style={{ width: "15%", textAlign: "center" }}
                  >
                    Proses
                  </Table.HeaderCell>
                  {/* <Table.HeaderCell style={{width:"10%",textAlign:"center"}}>#</Table.HeaderCell> */}
                  {/* <Table.HeaderCell style={{width:"15%"}}>SKPD</Table.HeaderCell>
                           <Table.HeaderCell style={{width:"15%"}}>OPD</Table.HeaderCell> */}
                  <Table.HeaderCell
                    style={{ width: "10%" }}
                    sorted={column === "no_bukti" ? direction : null}
                    onClick={this.handleSort("no_bukti")}
                  >
                    Nomor
                  </Table.HeaderCell>
                  <Table.HeaderCell
                    style={{ width: "8%" }}
                    sorted={column === "created_at" ? direction : null}
                    onClick={this.handleSort("created_at")}
                  >
                    Pembuatan
                  </Table.HeaderCell>
                  <Table.HeaderCell>Keterangan</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {result.length === 0 && (
                  <Table.Row>
                    <Table.Cell colSpan="5">Data tidak ditemukan</Table.Cell>
                  </Table.Row>
                )}
                {_.map(result, (item, i) => (
                  <Table.Row key={i}>
                    <Table.Cell>
                      {i + 1 + (activePage - 1) * this.state.itemPerPage}.
                    </Table.Cell>
                    <Table.Cell style={{ width: "5%", textAlign: "center" }}>
                      <Popup
                        trigger={
                          <Radio
                            toggle
                            checked={item.status}
                            style={{ marginBottom: "10px" }}
                            value={item.id}
                            index={i}
                            onChange={this.onToggleRadio}
                          />
                        }
                        header="Tambah ke STS Baru"
                        on="hover"
                        inverted
                      />
                    </Table.Cell>
                    <Table.Cell style={{ width: "10%", textAlign: "center" }}>
                      <Button.Group size="mini">
                        {!item.no_bukti.includes("ENTB") && (
                          <Button
                            color="red"
                            icon="trash"
                            onClick={() => this.onDelete(item.public_id, i)}
                          />
                        )}
                        <Button
                          color="blue"
                          icon="block layout"
                          index={i}
                          onClick={this.onOpenDetail}
                        />
                        <Button
                          color="green"
                          icon="pencil"
                          index={i}
                          onClick={this.onOpenEdit}
                        />
                      </Button.Group>
                    </Table.Cell>
                    {/* <Table.Cell>{item.org_skpd.nama}</Table.Cell>
                              <Table.Cell>{item.org_opd.nama}</Table.Cell> */}
                    <Table.Cell>{item.no_bukti}</Table.Cell>
                    <Table.Cell>{toDMYDate(item.created_at)}</Table.Cell>
                    <Table.Cell>{item.uraian}</Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
              <Table.Footer fullWidth>
                <Table.Row>
                  <Table.HeaderCell colSpan="8">
                    <Pagination
                      activePage={activePage}
                      onPageChange={this.handlePaginationChange}
                      totalPages={totalPages}
                    />
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Footer>
            </Table>
          </Segment>

          {this.state.is_open && (
            <STSAdd
              open={this.state.is_open}
              data={this.state.data_post}
              onClose={this.onCloseAddSTS}
            />
          )}

          {this.state.is_detail && (
            <ModalDetail
              open={this.state.is_detail}
              data_detail={this.state.data_detail}
              onClose={this.onCloseDetail}
            />
          )}

          {this.state.is_edit && (
            <ModalEdit
              open={this.state.is_edit}
              data_edit={this.state.data_edit}
              onClose={this.onCloseEdit}
            />
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Content/views/opd/_bp/BPNonSTS.js